/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgIntellinum = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M8.364 3.774c.039-1.157 1.019-1.96 2.17-1.736 2.066.402 4.127.843 6.17 1.351 1.347.335 2.23 1.612 2.234 3.025.006 3.006.003 6.012.003 9.018 0 1.733-.643 2.378-2.359 2.367h-.001c-.28 1.72-1.113 2.624-2.818 3.008-1.676.378-3.357.733-5.035 1.1-.328.071-.655.1-.99.091-1.013-.03-1.729-.733-1.731-1.75-.008-3.318-.01-6.64.001-9.958.005-1.228 1.089-2.464 2.294-2.672.123 1.226.028 2.456.053 3.683.014.703-.001 1.406.004 2.11.012 1.438.853 2.654 2.24 3.006 1.886.48 3.798.858 5.702 1.276.073.017.154 0 .232 0l.054-.006c.015-.009.043-.023.043-.025-.011-.027-.027-.053-.04-.079-.009-3.007-.017-6.013-.024-9.02-.004-1.818-.97-2.596-2.756-2.213-1.813.387-3.626.779-5.439 1.168-.006-1.248-.05-2.498-.007-3.744z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgIntellinum as Intellinum };
